import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat"; // ✅ fixed
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const Docking = () => {
  return (
    <div className="sector-detail">
      <Navbar />

      <header className="docking-hero">
        <h1>Pre-Docking Solutions</h1>
        <p>
          We provide comprehensive pre-docking solutions for vessels of all sizes, ensuring
          smooth and secure Docking operations while minimizing downtime. Our services are
          tailored to meet the needs of both commercial and industrial clients.
        </p>
      </header>

      <section className="sector-content">
        <h3 className="offer-title">What We Offer:</h3>
        <p>We offer expert pre-docking services to prepare vessels for dry docking, including
          inspections, documentation and coordination to ensure a smooth, efficient and
          compliant docking process.
        </p>
        <ul className="offer-list">
          <li>
            <span className="offer-icon"></span>
            Vessel docking & undocking coordination
          </li>
          <li>
            <span className="offer-icon"></span>
            Dry docking & maintenance services
          </li>
          <li>
            <span className="offer-icon"></span>
            Inspections & safety evaluations
          </li>
          <li>
            <span className="offer-icon"></span>
            Berth planning & management
          </li>
          <li>
            <span className="offer-icon"></span>
            Hull cleaning & underwater repairs
          </li>
          <li>
            <span className="offer-icon"></span>
            Efficient turnaround & downtime reduction
          </li>
        </ul>
      </section>

      <LiveChat />
      <QAChatbot/>
      <GetQuoteButton />
      <BackToTopButton/>
      <ScrollSocialIcons/>
      <Footer />
    </div>
  );
};

export default Docking;
